import { urls as LightningUrls } from 'lightning-common/lib/configuration';

import { getHtmlCopy } from '../../i18n';
import { AppleAppStoreBadge } from '../app-badge/AppleAppStoreBadge';
import { GooglePlayStoreBadge } from '../app-badge/GooglePlayStoreBadge';
import { LogoSoraWhite } from '../logos';
import { FooterPromoColumn } from './FooterPromos';

import './FooterSoraPromoColumn.scss';

interface FooterSoraPromoColumnProps {
    openInNewWindow?: boolean;
    showKindlePromo?: boolean;
}

export const FooterSoraPromoColumn = ({
    openInNewWindow,
    showKindlePromo,
}: FooterSoraPromoColumnProps) => (
    <FooterPromoColumn
        logo={<LogoSoraWhite />}
        openInNewWindow={openInNewWindow}
        showKindlePromo={showKindlePromo}
        tagLine={'sora.tagline'}
    >
        <ul
            aria-label={getHtmlCopy('sora.brandName')}
            className="footer__sora-promo-column-list"
        >
            <li>
                <AppleAppStoreBadge
                    href={LightningUrls.ntcIosSoraFooterUrl}
                    variant="white"
                />
            </li>
            <li>
                <GooglePlayStoreBadge
                    href={LightningUrls.ntcAndroidSoraFooterUrl}
                    variant="white"
                />
            </li>
        </ul>
    </FooterPromoColumn>
);
